const getDefaultState = () => {
  return {
    balance: [],
    balanceOperations: [],
    balanceNotFound: false,
    balanceError: null,
    loading: false,
    partners: [],
    partner: {},
    bankAccounts: [],
    bankAccount: {},
    billings: [],
    billing: {},
    status: "empty",
    filter: {
      partner: "",
      bankAccount: "",
      startDate: new Date(),
      endDate: new Date(),
      recipient_id: "",
    },
  };
};

// initial state
const state = getDefaultState();

export default {
  getDefaultState,
  ...state,
};
